import { Box, Typography, Grid, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { Container } from '../ui';
import logo from '../../assets/logo_transparent.png';

const exploreLinks = [
  { label: 'Programs', to: '/programs' },
  { label: 'About', to: '/about' },
  { label: 'FAQ', to: '/faq' },
];

const supportLinks = [{ label: 'Contact Us', to: '/faq#contact' }];

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        pt: 8,
        pb: 4,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container>
        <Grid container spacing={4}>
          {/* Brand */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              component={Link}
              to="/"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                fontWeight: 600,
                fontSize: 18,
                mb: 1.5,
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: 'background.paper',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Andromilky logo"
                  sx={{ width: '100%' }}
                />
              </Box>
              <span>Andromilky School</span>
            </Box>
            <Typography
              sx={{
                fontSize: 14,
                color: 'text.secondary',
                lineHeight: 1.6,
                maxWidth: 280,
              }}
            >
              Empowering the next generation of Entrepreneurs, leaders and Innovators.
            </Typography>
          </Grid>

          {/* Explore */}
          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 1.5 }}>
              Explore
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {exploreLinks.map((link) => (
                <MuiLink
                  key={link.to}
                  component={Link}
                  to={link.to}
                  underline="hover"
                  sx={{ fontSize: 14, color: 'text.secondary' }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Support */}
          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 1.5 }}>
              Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {supportLinks.map((link) => (
                <MuiLink
                  key={link.to}
                  component={Link}
                  to={link.to}
                  underline="hover"
                  sx={{ fontSize: 14, color: 'text.secondary' }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Contact */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 1.5 }}>
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
                info@andromilky.com
              </Typography>
              <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
                647-389-6899
              </Typography>
              <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
                Richmond Hill, ON
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Typography
          sx={{
            fontSize: 13,
            color: 'text.secondary',
            textAlign: 'center',
            mt: 6,
            pt: 3,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          &copy; {new Date().getFullYear()} Andromilky School. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
